export enum DATA_QA {
  ROOT = 'campaign-edit',
  CONTENT = 'campaign-edit__content',
  ERROR_NOTICE = 'campaign-edit__error-notice',
}

export enum CampaignAction {
  LAUNCH = 'LAUNCH',
  SCHEDULE = 'SCHEDULE',
}

export enum ValidationError {
  MISSING_CALL_CENTER = 'MISSING_CALL_CENTER',
  CALL_CENTER_ACCESS_DENIED = 'CALL_CENTER_ACCESS_DENIED',
  MISSING_CALLER_ID = 'MISSING_CALLER_ID',
  MISSING_DISCONNECT_MESSAGE = 'MISSING_DISCONNECT_MESSAGE',
  MISSING_LIST = 'MISSING_LIST',
  MISSING_VOICEMAIL = 'MISSING_VOICEMAIL',
  MISSING_START_TIME = 'MISSING_START_TIME',
  MIN_START_TIME = 'MIN_START_TIME',
  MAX_START_TIME = 'MAX_START_TIME',
  MISSING_END_TIME = 'MISSING_END_TIME',
  MIN_END_TIME = 'MIN_END_TIME',
  DESCRIPTION_EXCEEDS_CHARACTER_LIMIT = 'DESCRIPTION_EXCEEDS_CHARACTER_LIMIT',
  MISSING_SMS_MESSAGE = 'MISSING_SMS_MESSAGE',
  SMS_SEGMENT_EXCEEDS_LIMIT = 'SMS_SEGMENT_EXCEEDS_LIMIT',
  MISSING_CAMPAIGN_NAME = 'MISSING_CAMPAIGN_NAME',
  MISSING_CALL_TIMES_DAYS = 'MISSING_CALL_TIMES_DAYS',
  SYNC_FAILED = 'SYNC_FAILED',
}
